import * as React from "react";

type Size = "xs" | "sm" | "md" | "xl" | "2xl";
type Tone = "cloud" | "primary" | "solid";

type Props = ({ initial: string } | { src: string; alt: string }) & {
  size?: Size;
  tone?: Tone;
};

const SIZE: Record<Size, string> = {
  xs: "h-9 w-9",
  sm: "h-11 w-11",
  md: "h-[52px] w-[52px]",
  xl: "h-64 w-64 md:h-80 md:w-80",
  "2xl": "h-72 w-72 md:h-[28rem] md:w-[28rem]",
};

const TONE: Record<Tone, string> = {
  cloud: "bg-[color:var(--cloud-blue)] text-primary",
  primary: "bg-primary/10 text-primary",
  solid: "bg-primary text-white",
};

const TYPE: Record<Size, string> = {
  xs: "font-display text-[12px] font-semibold tracking-[0.08em]",
  sm: "text-h3 font-medium",
  md: "text-h2 font-semibold",
  xl: "text-h1 font-semibold",
  "2xl": "text-h1 font-semibold",
};

export function Avatar(props: Props) {
  const { size = "md", tone = "cloud" } = props;
  const box = `${SIZE[size]} flex-none rounded-full`;

  if ("src" in props) {
    return (
      <div className={`${box} overflow-hidden`}>
        <img
          src={props.src}
          alt={props.alt}
          className="h-full w-full object-cover"
        />
      </div>
    );
  }

  return (
    <div
      className={`${box} ${TONE[tone]} ${TYPE[size]} flex items-center justify-center`}
      aria-hidden="true"
    >
      {props.initial}
    </div>
  );
}
